import React from 'react';
import TimelineConnector from './TimelineConnector';

const WhatsappMessageEntry = ({ msg, showConnector, onEditMessage, onDeleteMessage, isDeleting = false }) => {
    const getMessagePreview = (html, wordLimit = 10) => {
        const raw = html == null ? '' : String(html);
        let text = raw;
        try {
            if (typeof window !== 'undefined' && typeof window.DOMParser !== 'undefined') {
                const doc = new window.DOMParser().parseFromString(raw, 'text/html');
                text = doc?.body?.textContent || '';
            } else {
                text = raw.replace(/<[^>]*>/g, ' ');
            }
        } catch (e) {
            text = raw.replace(/<[^>]*>/g, ' ');
        }

        const words = text.trim().split(/\s+/).filter(Boolean);
        const preview = words.slice(0, wordLimit).join(' ');
        return words.length > wordLimit ? `${preview} ...` : preview;
    };

    const formatDateOnly = (value) => {
        if (!value) return '';
        const d = new Date(value);
        if (isNaN(d.getTime())) return String(value);
        return d.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    return (
        <>
            <div className="list-group-item mb-0 note-card">
                <div className="note-content p-3">
                    <div className="note-header-row mb-2 d-flex justify-content-between align-items-center">
                        <h6 className="mb-0">
                            <span className="note-date">
                                <i className="fas fa-comment me-1" aria-hidden="true"></i>
                                Message
                            </span>
                            <div className="small text-muted mt-1">
                                Send on: {formatDateOnly(msg?.time_to_send)}
                            </div>
                        </h6>
                        <div className="btn-group">
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm d-flex align-items-center p-2"
                                onClick={() => onEditMessage && onEditMessage(msg)}
                                title="Edit message"
                                aria-label="Edit message"
                                style={{ minWidth: '32px', minHeight: '32px' }}
                                disabled={!onEditMessage}
                            >
                                <i className="fas fa-edit"></i>
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-danger btn-sm d-flex align-items-center p-2"
                                onClick={() => onDeleteMessage && onDeleteMessage(msg?.id)}
                                title="Delete message"
                                aria-label="Delete message"
                                style={{ minWidth: '32px', minHeight: '32px' }}
                                disabled={!onDeleteMessage || isDeleting}
                            >
                                {isDeleting ? (
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                ) : (
                                    <i className="fas fa-trash"></i>
                                )}
                            </button>
                        </div>
                    </div>
                    <div className="note-section">
                        <div className="section-title"><span className="icon">💬</span>WhatsApp Message</div>
                        <div style={{ lineHeight: '1.5' }}>{getMessagePreview(msg?.body, 10)}</div>
                    </div>
                </div>
            </div>
            <TimelineConnector show={showConnector} />
        </>
    );
};

export default WhatsappMessageEntry;
